import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../../environments/environment';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';

const API = environment.url_server;

@Component({
  selector: 'ngx-modal-nota-fiscal',
  templateUrl: './modal-nota-fiscal.component.html',
  styleUrls: ['./modal-nota-fiscal.component.scss']
})
export class ModalNotaFiscalComponent implements OnInit {
  @Input()
  public recibo: string;

  @ViewChild("card", null)
  private card: ElementRef;

  public dataHora: string;
  public valor: string;
  public qtdParcelas: string;
  public bandeira: string;
  public codAuth: string;
  public enterpriseFederalId: string;
  public customLogin = null;

  constructor(
    protected ref: NbDialogRef<ModalNotaFiscalComponent>,
    private http: HttpClient,
    private spinnerService: NgxSpinnerService,
    private encriptyService: EncriptyUtilService,
    public notificationService: NotificationsService
  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.enterpriseFederalId = this.encriptyService.decriptyBySecretKey(
      localStorage.getItem("bway-enterprise-federal-id")
    );
  }

  dismiss() {
    this.ref.close();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
